"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagBR = function FlagBR(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.13-84.45-140.72,6.15a7.06,7.06,0,0,0,0,12.06L8.13,108.81a7,7,0,0,0,7.34,0l148.85-90.6a7.06,7.06,0,0,0,0-12.06L15.47-84.45a7,7,0,0,0-7.34,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M68.3,12.18a56.5,56.5,0,1,1-56.5-56.5,56.51,56.51,0,0,1,56.5,56.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-36.68-16.72A56.23,56.23,0,0,0-42.76-2.26c31.31-2.36,77.65,6.4,107.13,35a56.12,56.12,0,0,0,3.68-15.62C37.6-8.49-4.5-17.6-36.68-16.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.14,31.46,15.64,36l4.76,0a.64.64,0,0,1,.37,1.15L17,40l1.43,4.53a.64.64,0,0,1-1,.71l-3.87-2.76L9.66,45.23a.64.64,0,0,1-1-.71L10.12,40,6.29,37.16A.64.64,0,0,1,6.67,36l4.75,0,1.51-4.51a.64.64,0,0,1,1.21,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.62,43.13l.65,1.94,2,0a.27.27,0,0,1,.16.49L33.83,46.8l.62,2a.28.28,0,0,1-.43.3l-1.67-1.18-1.66,1.18a.27.27,0,0,1-.42-.3l.62-2-1.65-1.22a.27.27,0,0,1,.16-.49l2.05,0,.64-1.94a.28.28,0,0,1,.53,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.15,22.89l.65,1.94,2,0a.27.27,0,0,1,.16.49L7.36,26.56l.62,2a.28.28,0,0,1-.43.31L5.89,27.63,4.22,28.82a.28.28,0,0,1-.42-.31l.62-2L2.77,25.34a.27.27,0,0,1,.16-.49l2.05,0,.64-1.94a.28.28,0,0,1,.53,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-29.7,20.54l.65,1.94,2.05,0a.27.27,0,0,1,.16.49l-1.65,1.22.62,1.95a.27.27,0,0,1-.42.3L-30,25.28l-1.67,1.18a.27.27,0,0,1-.42-.3l.62-1.95L-33.07,23a.27.27,0,0,1,.16-.49l2,0,.65-1.94a.27.27,0,0,1,.52,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.29,42.46.94,44.4H3a.27.27,0,0,1,.16.5L1.5,46.12l.62,2a.28.28,0,0,1-.42.31L0,47.19l-1.67,1.2a.28.28,0,0,1-.42-.31l.62-2-1.65-1.21a.28.28,0,0,1,.16-.5H-.88l.65-1.94a.27.27,0,0,1,.52,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-16.21,19.18l.53,1.59,1.68,0a.22.22,0,0,1,.13.4l-1.35,1,.5,1.6a.22.22,0,0,1-.34.25l-1.36-1-1.37,1a.22.22,0,0,1-.34-.25l.5-1.6-1.34-1a.22.22,0,0,1,.13-.4l1.68,0,.52-1.59a.23.23,0,0,1,.43,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.05-13.59l.67,2h2.09a.29.29,0,0,1,.17.52L35.29-9.83l.63,2a.28.28,0,0,1-.43.32l-1.7-1.22-1.7,1.22a.29.29,0,0,1-.44-.32l.63-2L30.6-11.07a.29.29,0,0,1,.17-.52h2.08l.67-2a.28.28,0,0,1,.53,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-27.39,9.47l.53,1.59h1.67a.23.23,0,0,1,.13.41l-1.34,1,.5,1.6a.22.22,0,0,1-.34.25l-1.37-1-1.36,1a.22.22,0,0,1-.34-.25l.5-1.6-1.34-1a.23.23,0,0,1,.13-.41h1.67l.53-1.59a.23.23,0,0,1,.43,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-19.31,31.84l.8,2.41,2.54,0a.34.34,0,0,1,.2.61l-2,1.51L-17,38.8a.34.34,0,0,1-.52.39l-2.07-1.48-2.06,1.48a.34.34,0,0,1-.52-.39l.76-2.41-2-1.51a.34.34,0,0,1,.2-.61l2.54,0,.8-2.41a.34.34,0,0,1,.65,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M42.92,43.63l.51,1.51,1.59,0a.21.21,0,0,1,.13.38l-1.29,1L44.34,48a.21.21,0,0,1-.32.24l-1.3-.93-1.3.93a.21.21,0,0,1-.33-.24l.48-1.52-1.28-1a.21.21,0,0,1,.12-.38l1.6,0,.5-1.51a.22.22,0,0,1,.41,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M48.5,32.09,49.15,34H51.2a.27.27,0,0,1,.15.5l-1.64,1.22.62,2a.28.28,0,0,1-.43.3l-1.66-1.19L46.57,38a.27.27,0,0,1-.42-.3l.62-2-1.65-1.22a.28.28,0,0,1,.16-.5h2L48,32.09a.27.27,0,0,1,.52,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagBR;
exports["default"] = _default;